import {handleLogout} from "components/utils"; import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from 'react';
import {Button, Col, Form, Row} from "react-bootstrap";
import axios from "axios";
import 'react-vertical-timeline-component/style.min.css';
import {VerticalTimelineElement} from 'react-vertical-timeline-component';
import {IpdPrescriptionWritingView} from "../../IpdPrescriptionWritingView";
import {PatientVitalsView} from "../../../customer/category/PatientVitalsView";


export const DischargeView = (props: { cookieEntityQr: string, data: any, caseData: any }) => {

    const [patientStatus, setPatientStatus] = useState("DISCHARGE");
    const [approvers, setApprovers] = useState(null);

    return (
        <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{background: '#ebecff', color: 'black'}}
            contentArrowStyle={{borderRight: '7px solid  #ebecff'}}
            date={props.data.createdAt + " - " + (props.data.createdByName && props.data.createdByName.split("@")[0])}
            iconStyle={{background: "#ebecff", fontSize: 25, textAlign: "center"}}
            icon=""
        >
            <h2 className="text-warning">Patient Discharged</h2>
            <div className="d-flex justify-content-between">
                <div className="flex-grow-1">
                    {props.data.patientStatus && props.data.patientStatus != "DISCHARGE" && <div className="d-flex gap-2">
                        <div className="fs-6 text-secondary">Discharge Status:</div>
                        <div className="fs-6">{props.data.patientStatus == "DEATH" ? "Death" : "LAMA"}</div>
                    </div>}
                    {props.data.extraDetails && <div className="d-flex gap-2">
                        <div className="fs-6 text-secondary">Clinical Approval by:</div>
                        <div className="fs-6">{JSON.parse(props.data.extraDetails).clinical_approver}</div>
                    </div>}
                    {props.data.extraDetails && <div className="d-flex gap-2">
                        <div className="fs-6 text-secondary">Accounts Approval by:</div>
                        <div className="fs-6">{JSON.parse(props.data.extraDetails).accounts_approver}</div>
                    </div>}
                    {props.data.notes && <div className="d-flex gap-2">
                        <div className="fs-6 text-secondary">Discharge Remarks:</div>
                        <div className="fs-6" dangerouslySetInnerHTML={{__html: props.data.notes}}/>
                    </div>}
                    {props.data.presId != 0 && props.data.presId &&
                        <IpdPrescriptionWritingView entityQr={props.cookieEntityQr} isEditable={false}
                                                    qrCode={props.data.clientQr} id={props.data.presId}/>}
                </div>
            </div>
        </VerticalTimelineElement>
    );
}